import { render, staticRenderFns } from "./AddClock.vue?vue&type=template&id=144481ef&scoped=true"
import script from "./AddClock.vue?vue&type=script&lang=js"
export * from "./AddClock.vue?vue&type=script&lang=js"
import style0 from "./AddClock.vue?vue&type=style&index=0&id=144481ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144481ef",
  null
  
)

export default component.exports